export enum SecondarySource {
  RECURLY = 'RECURLY',
  LEGACY = 'LEGACY',
  PORTAL = 'PORTAL',
  WEBSITE = 'WEBSITE',
  STUDIO = 'STUDIO',
  TESTCLOUD = 'TESTCLOUD',
}

export const TRIAL_SECONDARY_SOURCE = [
  SecondarySource.WEBSITE,
  SecondarySource.STUDIO,
  SecondarySource.TESTCLOUD,
];
